import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import authReducer from "./services/auth/authSlice";
import userReducer from "./services/users/userSlice";
import agentReducer from "./services/agents/agentSlice";
import cashMemoReducer from "./services/cashmemo/cashMemoSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    agents: agentReducer,
    cashMemo: cashMemoReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware(),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
